<template>
  <v-menu offset-y open-on-hover>
    <template v-slot:activator="{ on }">
      <v-btn fab small outline v-on="on" class="ml-1 extra-small" color="primary">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile
        v-for="(item, index) in suggestions"
        :key="index"
        @click="$emit('handleAddSugguestion', item.value)"
      >
        <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      suggestions: [
        {
          name: this.$t('Insert') + this.$t('Location'),
          value: 'location',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('video'),
          value: 'video',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('audio'),
          value: 'audio',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('image'),
          value: 'image',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('sticker'),
          value: 'sticker',
          description: ''
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/AddSuggestUserInput.vue